<template>
  <el-dialog v-dialog-drag title="文件预览" :visible.sync="showDialog" width="1200px" append-to-body :destroy-on-close="true" :before-close="cancel">
    <div v-if="fileDetails" class="el-dialog-div">
      <p><strong>文件名:</strong> {{ fileDetails.fileName }}</p>
      <div v-if="isImage" class="file-preview">
        <img :src="fileUrl" alt="文件预览" />
      </div>
      <div v-else-if="isPdf" class="file-preview">
        <iframe :src="fileUrl" width="100%" height="600px" frameborder="0"></iframe>
      </div>
      <div v-else-if="isText" class="file-preview">
        <pre class="file-content">{{ fileContent }}</pre>
      </div>
      <div v-else-if="isWord" class="file-preview word-preview">
        <vue-office-docx :src="wordContent"></vue-office-docx>
      </div>


      <div v-else>
        <p>不支持的文件类型</p>
        <el-link type="primary" @click="download">点击下载</el-link>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { fileDownload } from "@/utils/downFileUtils";
import VueOfficeDocx from "@vue-office/docx";
import VueOfficeExcel from "@vue-office/excel";
export default {
  name: 'FilePreview',
  props: ['showDialog', 'response'],
  components: {VueOfficeDocx,VueOfficeExcel},
  data() {
    return {
      fileDetails: null,
      fileUrl: null,
      fileContent: null,
      wordContent: null,
      fileId: ''
    };
  },
  computed: {
    isImage() {
      return this.fileDetails && ['image/png', 'image/jpeg', 'image/gif', 'image/bmp', 'image/webp'].includes(this.fileDetails.type);
    },
    isPdf() {
      return this.fileDetails && this.fileDetails.type === 'application/pdf';
    },
    isText() {
      return this.fileDetails && this.fileDetails.type === 'text/plain';
    },
    isWord() {
      return this.fileDetails && (this.fileDetails.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
    },
    isExcel(){
      return this.fileDetails && (this.fileDetails.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    }
  },
  watch: {
    'response': {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.getFileDetails(newVal);
        }
      },
      immediate: true
    }
  },
  methods: {
    cancel() {
      this.$emit('submit', 'cancel');
    },
    download() {
      fileDownload(this.response.file, this.response.fileName);
    },
    async getFileDetails(response) {
      try {
        const file = response.file;
        const fileName = decodeURI(response.fileName);
        this.fileDetails = { file, fileName, type: file.type };
        this.createFileUrl(file);
        if (this.isText) {
          await this.readFileContent(file);
        } else if (this.isWord) {
          await this.loadWordContent(file);
        }
      } catch (error) {
        console.log(error);
      }
    },
    createFileUrl(file) {
      const urlCreator = window.URL || window.webkitURL;
      this.fileUrl = urlCreator.createObjectURL(file);
    },
    async readFileContent(file) {
      try {
        const reader = new FileReader();
        reader.onloadend = (e) => {
          this.fileContent = e.target.result;
        };
        reader.readAsText(file);
      } catch (error) {
        console.log(error);
      }
    },
    async loadWordContent(file) {
      try {
        const blob = new Blob([file], {type: file.type});
        this.wordContent = URL.createObjectURL(blob)
      } catch (error) {
        console.log(error);
      }
    }
  },
  beforeDestroy() {
    if (this.fileUrl) {
      window.URL.revokeObjectURL(this.fileUrl); // 释放创建的 URL
    }
  }
}
</script>

<style>
.file-preview img {
  max-width: 100%;
  height: auto;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-top: 10px;
}

.file-content {
  white-space: pre-wrap;
  background-color: #f5f5f5;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-top: 10px;
}

.word-content {
  white-space: pre-wrap;
  background-color: #fff;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-top: 10px;
}

iframe {
  margin-top: 10px;
}
</style>